import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from "@emotion/styled";
import {ReactComponent as RightArrow} from '../assets/svgs/right-arrow-option.svg'

const FavoritesDropdownWrapper = styled.div`
  position: absolute;
  width: 200px;
  bottom: 90px;
  left: 40px;
  background: #6895e3;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  z-index: 100;
  color: white;
  gap: 10px;
  font-size: 12px;
`;

const Favorites = styled.div`
  display: ${(props) => (props.show ? 'block' : 'none')};
  // padding-left: 15px;
  div {
    margin: 10px;
    cursor: pointer;  /* Added cursor pointer for all favorites */
    &:hover {
      color: white;
      transition: all 0.4s;
      font-weight: 500;
    }
  }
`;

const Category = styled.div`
  cursor: pointer;
  font-size: 16px;
  &:hover {
    font-weight: 700;
    transition: all 0.4s;
  }
`;

function FavoritesDropdown({ show, onFavoriteClick }) {
  const [profile, setProfile] = useState(null);
  const [destinationDetails, setDestinationDetails] = useState([]);
  const [experienceDetails, setExperienceDetails] = useState([]);
  const [openCategories, setOpenCategories] = useState({
    Destinations: false,
    Experiences: false,
  });

  const { i18n } = useTranslation();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const tokenString = sessionStorage.getItem("token");
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';

  useEffect(() => {
    if (!tokenString) return;

    const fetchProfileAndFavorites = async () => {
      try {
        const response = await fetch(`${BASE_URL}RegisteredUserProfile/get`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${tokenString}`,
          },
        });

        if (!response.ok) throw new Error('Failed to fetch profile');
        const profileData = await response.json();
        setProfile(profileData);

        const destinationIds = profileData.destinationsFavorites || [];
        const destinations = await Promise.all(
          destinationIds.map(async (id) => {
            const res = await fetch(`${BASE_URL}Destination/${id}`);
            if (!res.ok) return null;
            const data = await res.json();
            return data;
          })
        );
        setDestinationDetails(destinations.filter(Boolean));

        const experienceIds = profileData.experiencesFavorites || [];
        const experiences = await Promise.all(
          experienceIds.map(async (id) => {
            const res = await fetch(`${BASE_URL}Experience/${id}`);
            if (!res.ok) return null;
            const data = await res.json();
            return data;
          })
        );
        setExperienceDetails(experiences.filter(Boolean));
      } catch (error) {
        console.error('Error fetching favorites:', error);
      }
    };

    fetchProfileAndFavorites();
  }, [tokenString, BASE_URL]);

  const toggleCategory = (category) => {
    setOpenCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  if (!show) return null;

  return (
    <FavoritesDropdownWrapper>
      <Category onClick={() => toggleCategory('Destinations')}>
        <RightArrow height={10} width={30} />
        {i18n.t("destinations")}
      </Category>
      <Favorites show={openCategories.Destinations}>
        {destinationDetails.length > 0 ? (
          destinationDetails.map((item) => (
            <div
              key={item.id}
              onClick={() => onFavoriteClick && onFavoriteClick(item)}  // clickable!
            >
              {item.name?.[selectedLanguage] || 'Unnamed Destination'}
            </div>
          ))
        ) : (
          <div>{i18n.t("noFavorites") || 'No favorite destinations.'}</div>
        )}
      </Favorites>

      <Category onClick={() => toggleCategory('Experiences')}>
        <RightArrow height={10} width={30} />
        {i18n.t("experiences")}
      </Category>
      <Favorites show={openCategories.Experiences}>
        {experienceDetails.length > 0 ? (
          experienceDetails.map((item) => (
            <div
              key={item.id}
              onClick={() => onFavoriteClick && onFavoriteClick(item)}  // clickable!
            >
              {item.name?.[selectedLanguage] || 'Unnamed Experience'}
            </div>
          ))
        ) : (
          <div>{i18n.t("noFavorites") || 'No favorite experiences.'}</div>
        )}
      </Favorites>
    </FavoritesDropdownWrapper>
  );
}

export default FavoritesDropdown;
